import React from "react";
import { useDispatch } from "react-redux";
import { sort_menu_categories } from "src/store/features/category-slice";

const SortbyDropdown = ({ type, sortBy, isDispatched = true, onClose }: any) => {
  const dispatch = useDispatch();

  const sortCategory = (value: string) => {
    if (sortBy && isDispatched) {
      dispatch(sortBy(value));
    } else if (sortBy && !isDispatched) {
      sortBy(value);
    } else {
      dispatch(sort_menu_categories(value));
    }
    // Close dropdown after selection
    if (onClose) {
      onClose();
    }
  };

  return (
    <div
      className="absolute right-0 top-full z-[100] mt-1.5 w-56 max-w-[calc(100vw-2rem)] rounded-xl border border-[#e5e7eb] bg-white py-2 shadow-[0_4px_6px_rgba(0,0,0,0.08)]"
      role="menu"
    >
      <button
        type="button"
        onClick={() => sortCategory("aToZ")}
        className="block w-full py-2.5 px-3 text-left text-sm font-normal text-[#828282] hover:bg-[#f1f1f2] hover:text-black"
      >
        {type ? "Table Numbers: 1 to 100" : "Alphabetically: A to Z"}
      </button>
      <button
        type="button"
        onClick={() => sortCategory("zToA")}
        className="block w-full py-2.5 px-3 text-left text-sm font-normal text-[#828282] hover:bg-[#f1f1f2] hover:text-black"
      >
        {type ? "Table Numbers: 100 to 1" : "Alphabetically: Z to A"}
      </button>
    </div>
  );
};

export default SortbyDropdown;
